<template>
    <div class="container-report-card">
        <div>
            <van-swipe class="my-swipe" indicator-color="white" @change="onChange" :loop="false">
                <van-swipe-item v-for="(r, index) in reports" :key="index">
                    <van-image class="cover" lazy-load fit="contain" :src="r.ratingImage" />
                </van-swipe-item>
                <template #indicator>
                    <div class="custom-indicator">{{ current + 1 }}/{{ reports.length }}</div>
                </template>
            </van-swipe>
        </div>

        <div style="margin-bottom: 200px;">
            <van-swipe :touchable="false" ref="swipe1" class="my-swipe1" :show-indicators="false" :loop="false">
                <van-swipe-item v-for="(v, index) in reports">
                    <div class="c-dash dashboard">
                        <div :class="{ item: true, last: getProperties(v).length === index }"
                            v-for="(item, index) in getProperties(v)">
                            <div class="sub-item">
                                <div class="t">
                                    <div class="divider" :style="{ 'background-color': color }"></div>
                                    <div class="label">{{ item[0].label }}</div>
                                </div>
                                <div class="b">{{ item[0].value ? item[0].value : '-' }}</div>
                            </div>
                            <div class="sub-item" v-if="item[1]">
                                <div class="t">
                                    <div class="divider" :style="{ 'background-color': color }"></div>
                                    <div class="label">{{ item[1].label }}</div>
                                </div>
                                <div class="b">{{ item[1].value ? item[1].value : '-' }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="c-dash dash1">
                        <div class="d-item">
                            <div class="title">四角</div>
                            <div class="value">{{ (v.corners / 100).toFixed(1) || '-' }}</div>
                        </div>
                        <div class="d-item">
                            <div class="title">四边</div>
                            <div class="value">{{ (v.edges / 100).toFixed(1) || '-' }}</div>
                        </div>
                        <div class="d-item">
                            <div class="title">居中</div>
                            <div class="value">{{ (v.centering / 100).toFixed(1) || '-' }}</div>
                        </div>
                        <div class="d-item">
                            <div class="title">表面</div>
                            <div class="value">{{ (v.surface / 100).toFixed(1) || '-' }}</div>
                        </div>
                        <div class="d-item">
                            <div class="title">总分</div>
                            <div class="value value1">{{ (v.totals / 100).toFixed(1) || '-' }}</div>
                        </div>
                    </div>
                    <div class="c-dash appraiser">

                        <van-image fit="contain" width="42px" height="42px"
                            style="min-width: 42px;min-height: 42px;border-radius: 200px;overflow: hidden;margin-left: 18px;"
                            :src="v.avatarImg"></van-image>
                        <div class="content">
                            <div class="title">
                                <van-image width="43px" height="20px" :src="levelIcons[v.appraiserLevel]"></van-image>
                                <div style="margin-left: 10px;color: #222222;font-size: 16px;">{{ v.appraiserName }}
                                </div>
                            </div>
                            <div
                                style="word-break: break-all;text-align: left;font-size: 10px;color: #8C8C8C;margin-top: 6px;">
                                {{ v.description }}
                            </div>
                        </div>
                    </div>

                    <div class="c-dash dash-preview">
                        <div class="preview-w">
                            <div class="preview-c">
                                <van-image class="review-img" fit="contain" :src="v.inStoreImage" />
                                <img @click="() => preview(v.inStoreImage)" class="preview-icon"
                                    src="https://oss.turingsenseai.com/1724829060259626005.jpg" alt="">
                            </div>
                            <div style="font-size: 10px;">入库照片</div>
                        </div>
                        <div class="preview-w" style="margin-left: 10px;">
                            <div class="preview-c">
                                <van-image class="review-img" fit="contain" :src="v.outStoreImage" />
                                <img @click="() => preview(v.outStoreImage)" class="preview-icon"
                                    src="https://oss.turingsenseai.com/1724829060259626005.jpg" alt="">
                            </div>
                            <div style="font-size: 10px;">出库照片</div>
                        </div>
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>


        <van-popup class="card-poster_1232" v-model="show" position="bottom" :style="{ height: '60%' }">
            <div class="popup-c">
                <van-image fit="contain" width="250" :src="imgUrl" alt="" />
                <div style="color: #242424;font-size: 16px;margin-top: 20px;">长按保存图片</div>
            </div>
        </van-popup>


        <div class="footer">
            <div class="btn" @click="progress">订单进度</div>
            <div class="btn" @click="save">保存到相册</div>
        </div>

        <vue-canvas-poster :widthPixels="0" :painting="painting" @success="successPainting"
            @fail="fail"></vue-canvas-poster>
    </div>
</template>

<script>
import { ImagePreview, Toast } from "vant";
import { uploadImage } from '../../common/api/common';
import { expertCardReport, expertCardReports } from "@/common/api/card.js";

export default {
    components: {
        [ImagePreview.Component.name]: ImagePreview.Component,
    },
    data() {
        return {
            current: 0,
            takePhoto: false,
            success: false,
            loading: false,
            imgUrl: null,
            data: { card: {} },
            reports: [],
            show: false,
            loader: null,
            levelIcons: {
                5: "https://oss.turingsenseai.com/1677139447856635256.png",
                4: "https://oss.turingsenseai.com/1677139455251971400.png",
                3: "https://oss.turingsenseai.com/1677139519200672996.png",
                2: "https://oss.turingsenseai.com/1677139527445050758.png",
                1: "https://oss.turingsenseai.com/1677139535438570369.png"
            },
            color: '#5EA9FF',
            classifyId: '',
            painting: {},
        };
    },
    methods: {
        getProperties(d) {
            return [
                [{
                    label: '卡牌名称',
                    value: d.cardName
                },
                {
                    label: 'IP',
                    value: d.ip,
                },],
                [{
                    label: '语言',
                    value: d.language
                },
                {
                    label: '年份',
                    value: d.vintage,
                },],
                [
                    {
                        label: '稀有度',
                        value: d.rarity,
                    },
                    {
                        label: '版本',
                        value: d.version,
                    },
                ],
                [
                    {
                        label: '序号',
                        value: d.serialNum
                    },
                    {
                        label: '鉴定号',
                        value: d.oaId,
                    },
                ]
            ];
        },
        onChange(index) {
            this.current = index;
            this.$refs.swipe1.swipeTo(index);
        },
        progress() {
            const r = this.reports[this.current] || {};

            if (window.__wxjs_environment === 'miniprogram') {
                wx.miniProgram.redirectTo({
                    url: `/subPackages/ai/card-offline/progress?order=${r.orderNo}`,
                });
            } else {
                Toast('请前往微信小程序 “鉴别记录-实物鉴别 ” 找到订单查看进度~');
            }
        },
        async fail(err) {
            console.log(err);
            // this.showResult = false;
        },
        dval(val) {
            return (val + '').length > 0 ? ((val + '').length - 1) * 10 : 0
        },
        imageDimensions(url) {
            return new Promise((resolve, reject) => {
                const img = new Image()

                // the following handler will fire after a successful loading of the image
                img.onload = () => {
                    const { naturalWidth: width, naturalHeight: height } = img
                    resolve({ width, height })
                }

                // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
                img.onerror = () => {
                    reject('There was some problem with the image.')
                }

                img.src = url
            });

        },

        async save() {
            const r = this.reports[this.current] || {};

            const cardName = r.cardName ? r.cardName + '' : '-';
            const oaId = r.oaId ? r.oaId + '' : '-';
            const corners = r.corners ? ((r.corners) / 100).toFixed(1) : '-';
            const edges = r.edges ? ((r.edges) / 100).toFixed(1) : '-';
            const centering = r.centering ? ((r.centering) / 100).toFixed(1) : '-';
            const surface = r.surface ? ((r.surface) / 100).toFixed(1) : '-';
            const totals = r.totals ? ((r.totals) / 100).toFixed(1) : '-';


           this.loader = Toast.loading({
                message: "生成中...",
                forbidClick: false,
                duration: 0,
                onOpened: async () => {
                    const {width,height} = await this.imageDimensions(r.ratingImage).catch(()=>{
                        this.loader.clear();
                    }); 

                    const ratio = width / height; 
                    let h, w, t, l;
                    
                    if(width <= height){
                        h = 700;
                        w = h * ratio;
                        t = 270;
                        l = (998 - w) / 2;
                    }else{
                        w = 900;
                        h = w / ratio;
                        t = (1263 - h) / 2;
                        l = (998 - w) / 2;
                    }

                    console.log(width,height,ratio,w,h, t);
                    
                    this.painting = {
                        width: `998px`,
                        height: `1463px`,
                        background: "https://oss.turingsenseai.com/1725361253338789529.jpg",
                        views: [
                            {
                                type: "text",
                                text: cardName,
                                css: {
                                    top: "1055px",
                                    left: "200px",
                                    color: "#363532",
                                    fontSize: "40px",
                                    fontWeight: 900,
                                },
                            },
                            {
                                type: "text",
                                text: oaId,
                                css: {
                                    top: "1143px",
                                    left: "200px",
                                    color: "#363532",
                                    fontSize: "40px",
                                    fontWeight: 900,
                                },
                            },
                            {
                                type: "text",
                                text: corners,
                                css: {
                                    top: "1320px",
                                    left: `${130 - this.dval(corners)}px`,
                                    color: "#222222",
                                    fontSize: "40px",
                                },
                            },
                            {
                                type: "text",
                                text: edges,
                                css: {
                                    top: "1320px",
                                    left: `${310 - this.dval(edges)}px`,
                                    color: "#222222",
                                    fontSize: "40px",
                                },
                            },
                            {
                                type: "text",
                                text: centering,
                                css: {
                                    top: "1320px",
                                    left: `${490 - this.dval(centering)}px`,
                                    color: "#222222",
                                    fontSize: "40px",
                                },
                            },
                            {
                                type: "text",
                                text: surface,
                                css: {
                                    top: "1320px",
                                    left: `${670 - this.dval(surface)}px`,
                                    color: "#222222",
                                    fontSize: "40px",
                                },
                            },
                            {
                                type: "text",
                                text: totals + '',
                                css: {
                                    top: "1320px",
                                    left: `${850 - this.dval(totals)}px`,
                                    color: "#EE9252",
                                    fontSize: "40px",
                                },
                            },



                            // {
                            //     type: "text",
                            //     text: '10',
                            //     css: {
                            //         top: "1335px",
                            //         left: "153px",
                            //         color: "#EE9252",
                            //         fontSize: "40px",
                            //     },
                            // },
                            // {
                            //     type: "text",
                            //     text: '10',
                            //     css: {
                            //         top: "1335px",
                            //         left: "470px",
                            //         color: "#222222",
                            //         fontSize: "40px",
                            //     },
                            // },
                            // {
                            //     type: "text",
                            //     text: '100%',
                            //     css: {
                            //         top: "1335px",
                            //         left: "780px",
                            //         color: "#222222",
                            //         fontSize: "40px",
                            //     },
                            // },
                            {
                                type: "image",
                                url: r.ratingImage,
                                css: {
                                    mode: 'aspectFill',
                                    top: t + "px",
                                    left: l + "px",
                                    width: w + 'px',
                                    height: h + 'px',
                                },
                            },
                        ],
                    }
                    

                    setTimeout(() => {
                        this.show = true;
                        this.loader.clear();
                    },300)


                },
            });

        },
        preview(image) {
            ImagePreview({
                images: [image],
                // startPosition: index,
                closeable: true
            });
        },
        async successPainting(src) {
            this.imgUrl = src;
            // this.loadingInstance.clear();
            uploadImage({
                imgB64: src.split(",")[1],
            }).then((res) => {
                if (res.errorMsg === "Success") {
                    // upload({image_url:res.imageUrl,id:this.id })
                }
            });
        },
    },
    mounted() {
        this.orderNo = this.$route.query.orderNo
        this.from = this.$route.query.from
        this.oaId = this.$route.query.oaid
        this.tagCode = this.$route.query.tagCode

        if (this.from === 'weapp') {
            expertCardReports({
                orderNo: this.orderNo
            }).then((res) => {
                if (res.errorMsg === 'Success') {
                    this.reports = res.report
                }
            });
        } else {
            expertCardReport({
                oaId: this.oaId === 'undefined' ? '' : this.oaId,
                tagCode: this.tagCode === 'undefined' ? '' : this.tagCode
            }).then((res) => {
                if (res.errorMsg === 'Success') {
                    this.reports = [res.report]
                }
            });
        }
    }
};
</script>

<style lang="scss">
.container-report-card {
    // height: 100vh;
    color: #fff;
    background-color: #fff;

    .my-swipe .van-swipe-item {
        color: #fff;
        text-align: center;
        background-color: #ffffff;
        height: 2 * 272px;

        .cover {
            height: 100%;
        }
    }

    .custom-indicator {
        position: absolute;
        right: 15px;
        bottom: 15px;
        padding: 4px 10px;
        font-size: 24px;
        border-radius: 50px;
        background: rgba(0, 0, 0, 0.1);
    }


    .appraiser {
        padding: 20px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;

        .content {
            margin-left: 23px;
            display: flex;
            flex-direction: column;

            .title {
                display: flex;
                align-items: center;
                margin-top: 12px;
            }
        }
    }

    .my-swipe1 {
        background-color: #F5F6FA;
        text-align: center;
        color: #313131;
        border-top-left-radius: 40px;
        border-top-right-radius: 40px;
    }


    .dashboard {
        padding: 5px 20px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;


        .van-grid-item__content {
            background-color: transparent;
            padding: 5px 0;
            display: flex;
            align-items: flex-start;
        }

        .t {
            margin-left: 10px;
            margin-bottom: 12px;
            display: flex;
            align-items: center;

            .label {
                font-size: 18px;
                color: #909090;
            }

            .divider {
                width: 6px;
                height: 14px;
                border-radius: 14px;
                margin-right: 12px;
            }
        }

        .b {
            margin-left: 10px;
            font-size: 20px;
            font-weight: 400;
            text-align: left;
            // color: #FFFFFF;
            // margin-left: 30px;
        }

        .item {
            width: 100%;
            display: flex;
            padding-top: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #ffffff3d;

            .sub-item {
                flex: 1;
            }

            &:last-of-type {
                border-bottom: unset;
            }
        }

        .last {
            border-bottom: unset;
        }
    }

    .dash1 {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 20px 0px;

        .d-item {
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0 40px;

            .value {
                margin-top: 10px;
            }

            .value1 {
                color: #EE9252;
            }
        }
    }

    .c-dash {
        margin: 20px;

        border-radius: 16px;
        background-color: #FFFFFF;
    }


    .dash-preview {
        padding: 20px 20px 5px 20px;
        display: flex;
        flex-direction: row;

        .preview-w {
            display: flex;
            flex-direction: column;
            justify-content: center;
            // align-items: center;
            width: 164px;
            position: relative;

            .preview-c {
                border-radius: 12px;
                overflow: hidden;
                background-color: #D9D9D9;
                position: relative;

                .review-img {
                    width: 164px;
                    height: 164px;
                }

                .preview-icon {
                    width: 30px;
                    height: 30px;
                    position: absolute;
                    right: 8px;
                    bottom: 10px;
                }
            }
        }
    }



    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        padding: 20px;
        padding-bottom: 40px;

        display: flex;

        .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
            margin: 0 10px;
            height: 80px;
            font-size: 34px;
            font-weight: 400;
            border-radius: 100px;
            background: linear-gradient(271.38deg, #3A94FF 2.99%, #74C8F5 100%);
        }
    }

    .card-poster_1232 {
        border-top-left-radius: 40px;
        border-top-right-radius: 40px;

        .popup-c {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            flex-direction: column;
        }
    }


}
</style>